<template>
  <v-container>
    <h1>User Details</h1>
    <span v-if="user">{{ user.fullName }}</span>
    <hr class="header" />

    <template v-if="user">
      <dl class="user-details-grid">
        <template v-for="field in userFields">
          <dt>{{ field.text }}</dt>
          <dd>{{ user[field.key] }}</dd>
        </template>
      </dl>

      <user-deals-table :deals="user.deals"></user-deals-table>

      <user-reviews-table
        :reviews="user.reviews"
        @delete="beginDeletingReview"
      ></user-reviews-table>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import UserDealsTable from './UserDealsTable'
import UserReviewsTable from './UserReviewsTable'

export default {
  name: 'User',
  components: {
    UserDealsTable,
    UserReviewsTable,
  },
  props: {
    id: String,
  },
  data: () => ({
    user: null,
    userFields: [
      { key: 'fullName', text: 'Name' },
      { key: 'email', text: 'Email' },
      { key: 'role', text: 'Role' },
      { key: 'receiveResources', text: 'Has Subscribed' },
      { key: 'communicationConsent', text: 'Has Consented to Communication' },
    ],
  }),
  computed: {
    ...mapGetters('feathers', ['apiUsers', 'apiReviews']),
  },
  beforeRouteEnter (to, from, next) {
    try {
      next(async vm => {
        const user = await vm.apiUsers.get(to.params.id, {
          query: {
            $include: {
              Deals: true,
              Reviews: true,
            },
          },
        })
        vm.setUserData(user)
      })
    } catch (error) {
      this.addAlert({
        type: 'error',
        message: `There was an error retrieving the user data: ${error.message}`,
      })
    }

    next()
  },
  methods: {
    setUserData (user) {
      this.user = user
    },

    async beginDeletingReview ({ id }) {
      const index = this.user.reviews.findIndex(review => review.id === id)

      if (confirm('Are you sure you wish to delete this review?')) {
        try {
          await this.apiReviews.remove(id)

          this.user.reviews.splice(index, 1)
        } catch (error) {
          this.addAlert({
            type: 'error',
            message: `There was an error deleting the review: ${error.message}`,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
dl {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 5px 20px;
  padding: 10px;

  dt {
    font-weight: bold;
    min-width: 50px;
  }
}
</style>
